import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import LandingPage from "./pages/landing";
import MainLayout from "./components/layout/MainLayout";
import { Button } from "./components/ui/button";
import { buildWhatsAppLink } from "./mock";
import { PhoneCall } from "lucide-react";

const useQuery = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};
const ConfirmationPage = () => {
  const query = useQuery();

  const name = query.get("name") || "";
  const phone = query.get("phone") || "";
  const location = query.get("location") || "";
  const paket = query.get("paket") || "";
  const notes = query.get("notes") || "";

  const handleOpenWhatsApp = () => {
    const url = buildWhatsAppLink({ name, phone, location, paket, notes });
    window.open(url, "_blank");
  };

  return (
    <div className="max-w-lg py-10 mx-auto">
      <div className="p-6 text-center border shadow-md rounded-3xl border-border bg-card">
        <p className="text-xs font-medium uppercase tracking-[0.18em] text-primary">
          Konfirmasi Pemesanan
        </p>

        <h1 className="mt-3 text-xl font-semibold tracking-tight text-foreground md:text-2xl">
          Tinggal 1 Langkah Lagi
        </h1>

        <p className="mt-2 text-xs text-muted-foreground md:text-sm">
          Klik tombol di bawah untuk langsung terhubung ke WhatsApp CINEURASA.
          Admin akan membalas dengan cepat.
        </p>

        <div className="px-4 py-3 mt-5 space-y-2 text-xs text-left rounded-2xl bg-secondary text-secondary-foreground md:text-sm">
          <p className="font-semibold text-foreground">Ringkasan data kamu</p>

          {name && (
            <p>
              <span className="font-medium">Nama:</span> {name}
            </p>
          )}
          {phone && (
            <p>
              <span className="font-medium">WhatsApp:</span> {phone}
            </p>
          )}
          {location && (
            <p>
              <span className="font-medium">Lokasi:</span> {location}
            </p>
          )}
          {paket && (
            <p>
              <span className="font-medium">Pilihan bumbu:</span> {paket}
            </p>
          )}
          {notes && (
            <p>
              <span className="font-medium">Catatan:</span> {notes}
            </p>
          )}
        </div>

        <Button
          onClick={handleOpenWhatsApp}
          className="mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-primary px-6 py-2 text-sm font-semibold text-primary-foreground shadow-md transition hover:bg-primary/90 hover:-translate-y-0.5"
        >
          <PhoneCall className="w-4 h-4" />
          <span>Kirim Pesan Sekarang</span>
        </Button>

        <p className="mt-3 text-[11px] text-muted-foreground">
          Admin akan membalas dengan cepat dan membantu kamu sampai proses
          pembayaran selesai.
        </p>
      </div>

      <p className="mt-4 text-center text-[11px] text-muted-foreground">
        Catatan: Saat ini alur pemesanan masih berbasis WhatsApp langsung tanpa
        sistem backend. DATA MASIH DIMOCK dan hanya disimpan di browser kamu.
      </p>
    </div>
  );
};

function AppRoutes() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/konfirmasi" element={<ConfirmationPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
